import { z } from 'zod';

import { WordResponseSchema } from './word-response.dto';

export const ValidateWordsExistenceResponseSchema = z.object({
  foundWords: z.array(z.record(z.string(), WordResponseSchema)),
});

export type IValidateWordsExistenceResponseDto = z.infer<
  typeof ValidateWordsExistenceResponseSchema
>;
